export enum ItemType {
  FEEDSTOCK = 'feedstock',
  FINISHED = 'finished',
  VIRTUAL = 'virtual',
}
